import React from 'react'
import classes from "./styles/RightSideWiraaAds.module.css";


export const RightSideWiraaAds = () => {
  return (
    <a href="https://www.wiraa.com/" target="_blank" rel="noopener noreferrer" className={classes.link}>
    <div className={classes.container}>
        <img src="https://cdn-icons-png.flaticon.com/128/3135/3135687.png" alt="jobicon" className={classes.icon} />
        <h6 className={classes.title}>Want to work from anywhere? <br/> Start your remote career now!</h6>
        <p className={classes.para}>Browse 1,000+ Remote Opportunities from verified companies around the world.</p>
        <div className={classes.btnCon}><button className={classes.btn}>Explore Now</button></div>
    </div></a>
  )
}
